"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator")),
    _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _lodash = _interopRequireDefault(require("lodash.orderby")),
    _utils = require("../utils"),
    _constants = require("../constants"),
    _PartUploader = _interopRequireDefault(require("./PartUploader"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var source, i = 1; i < arguments.length; i++) {
    source = null == arguments[i] ? {} : arguments[i], i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2["default"])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var FileUploader = function FileUploader(_ref) {
  var _this = this,
      addUploadTasksToQueue = _ref.addUploadTasksToQueue,
      apiClient = _ref.apiClient,
      progress = _ref.progress,
      error = _ref.error,
      complete = _ref.complete,
      file = _ref.file,
      assetId = _ref.assetId,
      organisationId = _ref.organisationId,
      bucketKey = _ref.bucketKey,
      metaData = _ref.metaData,
      cacheUploadId = _ref.cacheUploadId,
      _ref$uploadedParts = _ref.uploadedParts,
      uploadedParts = void 0 === _ref$uploadedParts ? [] : _ref$uploadedParts,
      _ref$uploadedBytes = _ref.uploadedBytes,
      uploadedBytes = void 0 === _ref$uploadedBytes ? 0 : _ref$uploadedBytes,
      ORIGINAL = _ref.ORIGINAL;

  (0, _classCallCheck2["default"])(this, FileUploader), this.start = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee() {
    var result;
    return _regenerator["default"].wrap(function (_context) {
      for (;;) {
        switch (_context.prev = _context.next) {
          case 0:
            if (_context.prev = 0, _this._uploadId) {
              _context.next = 9;
              break;
            }

            return _context.next = 4, (0, _utils.createS3MultipartUpload)(_this._apiClient, _this._bucketKey, _this._file.type, _this._organisationId);

          case 4:
            if (result = _context.sent, result) {
              _context.next = 7;
              break;
            }

            return _context.abrupt("return");

          case 7:
            _this._uploadId = result, (0, _utils.saveAssetInLocalStorage)(_this._assetId, _this.getLocalCache());

          case 9:
            return _context.next = 11, _this.addUploadPartsTasks();

          case 11:
            _context.next = 16;
            break;

          case 13:
            _context.prev = 13, _context.t0 = _context["catch"](0), _this.setStatusToError();

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 13]]);
  })), this.getLocalCache = function () {
    return {
      assetId: _this._assetId,
      uploadId: _this._uploadId,
      bucketKey: _this._bucketKey,
      uploadedParts: _this._uploadedParts,
      uploadedBytes: _this._fileBytesUploaded,
      filename: _this._file.name,
      metaData: _this._metaData,
      lastModified: _this._file.lastModified,
      assetFiles: {
        ORIGINAL: _this._ORIGINAL
      }
    };
  }, this.updateUploadedBytes = function (value) {
    _this._fileBytesUploaded = value, _this._progress(_this._fileBytesUploaded);
  }, this.handlePartUploaded = function (part) {
    return _this._uploadedParts.push(part), (0, _utils.saveAssetInLocalStorage)(_this._assetId, _this.getLocalCache()), _this._uploadedParts.length === _this._chunksCount ? _this.completeFileUpload() : null;
  }, this.abortFileUploading = function () {
    _this._partUploaders.forEach(function (partUploader) {
      return partUploader.xhr && partUploader.xhr.abort();
    }), _this._partUploaders = [];
  }, this.setStatusToError = function () {
    return _this.abortFileUploading(), _this._error();
  }, this.getFileBlob = function (partNumber) {
    var start = (partNumber - 1) * _constants.FILE_CHUNK_SIZE,
        end = partNumber * _constants.FILE_CHUNK_SIZE;
    return partNumber < _this._chunksCount ? _this._file.slice(start, end) : _this._file.slice(start);
  }, this.completeFileUpload = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee2() {
    var parts, result;
    return _regenerator["default"].wrap(function (_context2) {
      for (;;) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return parts = (0, _lodash["default"])(_this._uploadedParts, "PartNumber"), _context2.next = 3, (0, _utils.completeS3MultipartUpload)(_this._apiClient, _this._uploadId, _this._bucketKey, _this._organisationId, parts);

          case 3:
            if (result = _context2.sent, result) {
              _context2.next = 6;
              break;
            }

            return _context2.abrupt("return");

          case 6:
            (0, _utils.deleteAssetFromLocalStorage)(_this._assetId), _this._file.type.includes("video/") && (0, _utils.transcodeVideo)(_this._apiClient, _this._organisationId, _this._assetId), _this._complete();

          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })), this.calculatePartsToUpload = function () {
    var partsArray = Array.from(Array(_this._chunksCount).keys()).map(function (i) {
      return i + 1;
    }),
        parts = [];
    return partsArray.forEach(function (partNumber) {
      _this._uploadedParts.some(function (_ref4) {
        var PartNumber = _ref4.PartNumber;
        return PartNumber === partNumber;
      }) || parts.push(partNumber);
    }), parts;
  }, this.addUploadPartsTasks = function () {
    var partsToUpload = _this.calculatePartsToUpload();

    return partsToUpload.length || _this._uploadedParts.length !== _this._chunksCount ? _this.addUploadPartsTasksToQueue(partsToUpload) : _this.completeFileUpload();
  }, this.addUploadPartsTasksToQueue = function () {
    var _ref5 = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee3(parts) {
      var urls, tasks;
      return _regenerator["default"].wrap(function (_context3) {
        for (;;) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.next = 2, (0, _utils.getPartSignedUrls)(_this._apiClient, _this._uploadId, _this._bucketKey, _this._organisationId, parts);

            case 2:
              if (urls = _context3.sent, urls) {
                _context3.next = 5;
                break;
              }

              return _context3.abrupt("return");

            case 5:
              return tasks = urls.reduce(function (tasksArr, _ref6) {
                var partNumber = _ref6.partNumber,
                    url = _ref6.url;
                return tasksArr.push(_this.createUploadPartTask(partNumber, url)), tasksArr;
              }, []), _context3.abrupt("return", void _this._addUploadTasksToQueue(tasks));

            case 7:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function () {
      return _ref5.apply(this, arguments);
    };
  }(), this.createPartHandlers = function () {
    return {
      onComplete: _this.handlePartUploaded,
      onProgress: function onProgress(bytes) {
        _this.updateUploadedBytes(_this._fileBytesUploaded + bytes);
      },
      onError: function onError(bytes) {
        return _this.updateUploadedBytes(_this._fileBytesUploaded - bytes), _this.setStatusToError();
      }
    };
  }, this.createUploadPartTask = function (partNumber, url) {
    return function () {
      var _ref7 = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee4(done) {
        var handlers, partUploader;
        return _regenerator["default"].wrap(function (_context4) {
          for (;;) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return handlers = _this.createPartHandlers(), _context4.prev = 1, partUploader = (0, _PartUploader["default"])(_objectSpread({}, handlers, {
                  partNumber: partNumber,
                  url: url,
                  blob: _this.getFileBlob(partNumber)
                })), _this._partUploaders[partNumber] = partUploader, _context4.next = 6, partUploader.uploadPart();

              case 6:
                _context4.next = 12;
                break;

              case 8:
                return _context4.prev = 8, _context4.t0 = _context4["catch"](1), _context4.next = 12, _this.setStatusToError();

              case 12:
                return _context4.abrupt("return", done());

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[1, 8]]);
      }));

      return function () {
        return _ref7.apply(this, arguments);
      };
    }();
  }, this._apiClient = apiClient, this._addUploadTasksToQueue = addUploadTasksToQueue, this._progress = progress, this._error = error, this._complete = complete, this._assetId = assetId, this._organisationId = organisationId, this._file = file, this._bucketKey = bucketKey, this._metaData = metaData, this._chunksCount = Math.floor(this._file.size / _constants.FILE_CHUNK_SIZE) + 1, this._fileBytesUploaded = uploadedBytes, this._uploadedParts = uploadedParts, this._partUploaders = [], this._uploadId = cacheUploadId || "", this._ORIGINAL = ORIGINAL;
},
    _default = function _default(data) {
  return new FileUploader(data);
};

exports["default"] = _default;